import { DescribeProperty } from '../../common';

export class ProjectAccessControlPolicyEntryResponse {
  @DescribeProperty({
    description: 'The ID of created project',
    example: '123e4567-e89b-12d3-a456-426614174000',
    type: 'string',
    format: 'uuid',
  })
  id: string;

  @DescribeProperty({
    description: 'Is project access protected by password',
    type: 'boolean',
    format: 'boolean',
  })
  isPasswordProtected: boolean;

  @DescribeProperty({
    description: 'Is project access control policy owner',
    type: 'boolean',
    format: 'boolean',
  })
  isOwner: boolean;

  @DescribeProperty({
    description: 'When true, non-owners are allowed to download the source model input file',
    type: 'boolean',
    format: 'boolean',
  })
  allowSourceModelDownload: boolean;

  @DescribeProperty({ description: 'Updated at', type: 'string', format: 'date-time' })
  updatedAt: Date;

  @DescribeProperty({ description: 'Created at', type: 'string', format: 'date-time' })
  createdAt: Date;
}
